import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {setCreateButton, setSearchHandler, setSearchString, setTitle} from "../actions/main";
import {Link, useNavigate, useParams} from "react-router-dom";
import TableView from "../components/TableView";
import {ConfirmDialog, confirmDialog} from "primereact/confirmdialog";
import {ClientService} from "../services/ClientService";
import {ArtistService} from "../services/ArtistService";
import {ConfirmPopup} from "primereact/confirmpopup";
import {EventsService} from "../services/EventsService";
import Total from "../components/Total";
import {Button} from "primereact/button";
import {Calendar} from "primereact/calendar";
import {InputText} from "primereact/inputtext";
import formater from "../helpers/formater";

function Events() {
    const ss = useSelector((s) => {
        return s.searchString
    })
    const dispatch = useDispatch()
    const [date, setDate] = useState(() => {
        if(localStorage.getItem('events_date')){
            // console.log('tttttime', localStorage.getItem('events_date'))
            // console.log('aaaaaaaa', new Date(parseInt(localStorage.getItem('events_date'))))
            return new Date(parseInt(localStorage.getItem('events_date')))
        } else {
            return new Date()
        }
    })
    const locationParams = useParams()
    const [data, setData] = useState(false)
    const [loading, setLoading] = useState(true)
    const currentDepartment = useSelector(function (state) {
        return state.currentDepartment
    });
    const searchString = useSelector((s) => s.searchString) || ''
    const navigation = useNavigate()
    const [filter, setFilter] = useState({})
    const [sortOrder, setSortOrder] = useState(() => {
        return localStorage.getItem('events_sort_order') || 'desc'
    })


    let defaultColumns = [
        // {name: 'id', label: '№', selected: true},
        {name: 'name', label: 'Название', selected: true},
        {name: 'date', label: 'Дата', selected: true},
        {name: 'ticket_sale', label: 'Продано билетов', selected: true},
        {name: 'is_canceled', label: 'Отменено?', selected: true},
        // {name: 'client', label: 'Источник', selected: true},
    ];


    function setTableRowsHandler(data) {
        setTableRows(data)
    }


    function updateData(params, currentSortOrder = sortOrder) {


        let arr = []
        const requestParams = {
            ...params,
            sort_by: 'date',
            sort_order: currentSortOrder
        }
        EventsService.GetList(requestParams, '').then((response, h) => {

            // Check if response has errors
            if (response && response.errors) {
                console.error('EventsService.GetList error:', response.errors);
                setLoading(false);
                setData({items: [], _meta: {}});
                return;
            }

            // Check if response.items exists and is an array
            if (!response || !response.items || !Array.isArray(response.items)) {
                console.warn('EventsService.GetList: invalid response structure', response);
                setLoading(false);
                setData({items: [], _meta: response?._meta || {}});
                return;
            }

            // if (response.items) {
            // setData(response)
            response.items.map((el) => {
                // console.log(new Date(el.date).getMonth())
                // console.log(date.getMonth())
                // console.log(new Date(el.date).getFullYear())
                // console.log(date.getFullYear())
                if (!searchString && new Date(el.date).getMonth() === date.getMonth() && new Date(el.date).getFullYear() === date.getFullYear()) {
                    arr.push(el)
                } else if(searchString){
                    arr.push(el)
                }
            })
            setLoading(false)
            response.items = arr

            setData(response)



        })
    }


    const rowActions = [
        {
            'label': 'Редактировать',
            icon: 'pi pi-pencil',
            command: (e) => {
                navigation('/artist/' + e.item.rowId)
            }
        },
        {
            'label': 'Удалить',
            icon: 'pi pi-trash',
            command: (e) => {

                confirmDialog({
                    message: 'Вы хотите удалить этого события?',
                    header: 'Подтвердите удаление',
                    icon: 'pi pi-info-circle',
                    acceptClassName: 'p-button-danger',
                    accept: () => {
                        EventsService.Delete(e.item.rowId).then((response) => {
                            updateData()
                        })
                    },
                    acceptLabel: 'Да',
                    reject: () => {
                        return false
                    },
                    rejectLabel: 'Нет'
                });
            }
        }
    ];


    const handlerRawActions = (elId) => {
        const currentRow = data.items.find((el) => {
            return el.id === elId
        })

        if (currentRow) {
            rowActions.map((actionRow, k) => {
                actionRow.rowId = elId


            })

            return rowActions;
        }
    }

    const handlePageClick = (event) => {
        setLoading(true);
        updateData({...filter, page: ++event.selected})
    }

    const handleScroll = (e) => {
        // if(!loading) {
            localStorage.setItem('events_scroll', window.pageYOffset)
        // }
    }

    useEffect(() => {
        window.addEventListener('scroll', handleScroll, true);
        // Remove listener when component unmounts
        // window.removeEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll, true);
        }
    }, [])

    const tableValue = (propName, el) => {
        switch (propName) {
            case 'name':
                return <Link to={'/event/' + el.id}>{el[propName]}</Link>
                break
            case 'is_canceled':
                return formater.boolean(el[propName])
                break

            default:

                return (
                    el[propName]
                )
        }
    }

    const [tableRows, setTableRows] = useState(defaultColumns)


    useEffect(() => {
        // alert(localStorage.getItem('events_scroll'))
        if(localStorage.getItem('events_scroll')){
            window.scrollTo({ top: parseInt(localStorage.getItem('events_scroll')), behavior: "smooth" });
        }
    }, [data]);


    useEffect(() => {
        dispatch(setTitle(false))
        dispatch(setCreateButton(false))

        dispatch(setSearchHandler(searchHandler2))
        dispatch(setSearchString(''))
        // Only set client_id if currentDepartment is not null/undefined
        const filterData = currentDepartment ? {filter: {client_id: currentDepartment}} : {filter: {}}
        setFilter(filterData)
        updateData(filterData)

        if(date){
          localStorage.setItem('events_date', date.getTime())
        }
    }, [currentDepartment, date]);


    const searchHandler2 = (e, string) => {

        setLoading(true)

        updateData({
            filter: {
                // client_id: currentDepartment,
                s: string
            }
        })

        e.preventDefault()
    }


    const prevMonthHandler = (e) => {
        const d = new Date(JSON.parse(JSON.stringify(date)));
        d.setMonth(d.getMonth() - 1)
        setDate(d)
    }
    const nextMonthHandler = (e) => {
        const d = new Date(JSON.parse(JSON.stringify(date)));
        d.setMonth(d.getMonth() + 1)
        setDate(d)
    }

    const toggleSortOrder = () => {
        const newOrder = sortOrder === 'desc' ? 'asc' : 'desc'
        setSortOrder(newOrder)
        localStorage.setItem('events_sort_order', newOrder)
        setLoading(true)
        const filterData = currentDepartment ? {filter: {client_id: currentDepartment}} : {filter: {}}
        updateData(filterData, newOrder)
    }



    return (
        <div className={'product-wrapper'}>

            <div className="page-title">
            <div className="d-flex align-items-center justify-content-between">
                <div className={'d-flex align-items-center'}>
                    <h3>{'Мероприятия'}</h3>

                    <Link
                        className={'btn m-l-30 btn-success btn-block flex-shrink-0 btn-pill d-none d-md-block'}
                        to={'/event/create'}>
                        <span className="fa fa-plus-circle"></span> Добавить
                    </Link>
                </div>


                <div className={'d-flex gap-5'}>
                    <div className={'d-flex gap-5 flex-shrink-0'}>

                        <div className={'d-flex gap-2 flex-shrink-0 justify-content-end p-button-group'}>
                            <Button icon={'pi pi-angle-left'} text severity="secondary"
                                    onClick={(e) => prevMonthHandler()}/>

                            <Calendar
                                inputClassName={' p-component p-button-secondary p-button p-button-text'}
                                value={date} onChange={(e) => setDate(e.value)} view="month"
                                dateFormat="MM yy"/>

                            <Button icon={'pi pi-angle-right'} text severity={'secondary'}
                                    onClick={(e) => nextMonthHandler()}/>
                        </div>

                        <div className={'d-flex gap-2 flex-shrink-0 align-items-center'}>
                            <span className="text-muted d-none d-md-inline" style={{fontSize: '0.85rem'}}>Сортировка:</span>
                            <Button 
                                icon={sortOrder === 'desc' ? 'pi pi-sort-amount-down' : 'pi pi-sort-amount-up'} 
                                label={sortOrder === 'desc' ? 'Новые' : 'Старые'}
                                severity={sortOrder === 'desc' ? 'primary' : 'secondary'}
                                outlined={sortOrder !== 'desc'}
                                onClick={() => toggleSortOrder()}
                                tooltip={sortOrder === 'desc' ? 'По убыванию даты (сначала новые)' : 'По возрастанию даты (сначала старые)'}
                                tooltipOptions={{position: 'bottom'}}
                            />
                        </div>

                    </div>
                    <form onSubmit={(e) => searchHandler2(e, searchString)}
                          className={'theme-form d-flex w-100'}>

                        <div className="input-group ">
                            <InputText className={'btn-pill form-control'}
                                       value={searchString}
                                       placeholder={'Поиск по разделу'}
                                       onChange={(e) => {
                                           dispatch(setSearchString(e.target.value))
                                       }
                                       }/>

                            {/*<input type="search" className={'form-control btn-pill p-3'}*/}
                            {/*       placeholder={'Поиск по телефону, имени, email, id...'}*/}
                            {/*       // value={search}*/}
                            {/*       onChange={(e) => dispatch(setSearchString(e.target.value))}/>*/}

                            <button type={'submit'}
                                    className={'btn btn-primary btn-pill '}>
                                <span className="fa fa-search"></span>
                            </button>
                        </div>

                    </form>


                </div>


            </div>
            </div>

            <ConfirmDialog/>
            <div className="card">
                <TableView id={'artists-list'} tableRows={tableRows} data={data}
                           tableValue={tableValue}
                           loading={loading}


                           setTableRows={setTableRowsHandler} handleEdit={(e) => ''} rowActions={rowActions}
                           massRowActions={false} massActionHander={false}
                           rowActionsHandler={handlerRawActions}
                           hideSettings={true}
                           tableClass={'events-table'}/>


            </div>


            <Total data={data} handlePageClick={handlePageClick}/>


        </div>
    )
}

export default Events